var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"approved-feedback",class:{ fallback: _vm.isFallback }},[_c('AnimationCheck')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }